import { Invitation, InvitationDto } from 'types/invitation';

export function mapInvitationToDto(
  invitation: Pick<Invitation, 'emailAddress'>
): Pick<InvitationDto, 'email_address'> {
  return {
    email_address: invitation.emailAddress,
  };
}
